import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {saveAs} from 'file-saver/FileSaver';
import {VariantsService} from '../../pages-services/variants.service';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmPopupComponent} from '../../components/confirm-popup/confirm-popup.component';
import {ToasterService} from 'angular2-toaster';
import {ProductsService} from "../../pages-services/products.service";

@Component({
    selector: 'app-variants',
    templateUrl: './variants.component.html',
    styleUrls: ['./variants.component.css']
})

export class VariantsComponent implements OnInit {
    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: true
    };

    tableInsideConfiguration = {};
    isLoaded = false;

    columnsDep = [
        {key: 'variantName', title: 'ID/Name/Description'},
        {key: 'category', title: 'Category'},
        {key: 'subcategory', title: 'Subcategory'}
    ];

    columns = [
        {key: 'id', title: 'ID/Name/Description'},
        {key: 'category', title: 'Category'},
        {key: 'subcategory', title: 'Subcategory'},
        {key: 'price', title: 'Price'},
        {key: 'width', title: 'Associated With'},
        {key: 'isDefault', title: 'Default'},
        {key: 'isStatic', title: 'Static'},
        {key: 'isVisualized', title: 'Visualized'},
        {key: 'actions', title: 'Actions'}
    ];

    data = [];
    rows = [];
    selected = new Set();
    searchTerm = '';
    selectedVariants: Array<any> = [];
    selectedProduct: any;
    products: any[];

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private variantsService: VariantsService,
        private productsService: ProductsService,
        private translateService: TranslateService,
        private router: Router,
        private toasterService: ToasterService
    ) {
        this.rows = this.data;

        // clone rows with some differences
        this.tableInsideConfiguration = JSON.parse(JSON.stringify(this.tableConfiguration));
        this.tableInsideConfiguration['checkboxes'] = false;
        this.tableInsideConfiguration['paginationEnabled'] = false;
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.variantsService.getGroupedList().subscribe(({variants}) => {
            this.data = variants;
            this.rows = this.data;

            // data already loaded
            this.isLoaded = true;
        });

        this.productsService.getList().subscribe((products) => {
            this.products = products.products
        });
    }

    toggleRow({target: {checked}}, row) {
        if (checked) {
            this.selected.add(row.id);
        } else {
            this.selected.delete(row.id);
        }
    }

    isRowSelected(row) {
        return this.selected.has(row.id);
    }

    linkToVariant(rowID) {
        this.router.navigate([`/variants/${rowID}`]);
    }

    eventEmitted(e) {
        switch (e.event) {
            case 'onSelectAll':
                this.data.forEach((val, key) => {
                    if (this.selected.has(val.id)) {
                        this.selected.delete(val.id);
                    } else {
                        this.selected.add(val.id);
                    }
                });
            break;
        }
    }

    search() {
        this.rows = this.data.filter((row) => {
            if(this.selectedProduct && !row.products.includes(this.selectedProduct)){
                return false;
            }

            if(this.searchTerm.length === 0){
                return true;
            }

            return (row.name && row.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
                row.description && row.description.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
                row.category && row.category.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
                row.subcategory && row.subcategory.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1)
        });
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeVariant(id) {
        this.selectedVariants.push(this.rows.find((r) => r.id === id));
        this.confirmPopup.show();
    }

    confirm(res) {
        if(res) {
            if (this.selectedVariants.length > 0) {
                this.variantsService.delete(this.selectedVariants.map((v) => v.id)).subscribe(async (resp) => {
                    this.selectedVariants = [];
                    let successMessage = await this.translateService.get('webpanel.variants.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        } else {
            this.selectedVariants = [];
        }
    }

    decline() {
        this.selectedVariants = [];
    }

    async exportToCSV() {
        const data = this.data.filter((row, index) => this.selected.has(row.id));
        let csvContent = '';
        let dataString = '';
        const x: Array<any> = [];
        let keys = Object.keys(this.data[0]);

        // remove unnecessary index
        keys = keys.filter(item => item !== 'data');


        for (let index = 0; index < data.length; index++) {
            let row = data[index];
            x[index] = [];

            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                if (typeof row[key] === 'object') {
                    row[key] = JSON.stringify(row[key]);
                }
                let val = row[key];
                if (['title', 'description', 'category', 'subcategory'].indexOf(key) !== -1) {
                    if(val) {
                        val = await this.translateService.get(val).toPromise();
                    }
                }
                x[index].push(val);
            }
        }

        csvContent += keys.join(';') + '\n';
        x.forEach((row, index) => {
            dataString = row.join(';');
            csvContent += index < data.length ? dataString + '\n' : dataString;
        });

        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8'});
        saveAs(blob, 'export.csv');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/variants/variants.component.ts